import NotificationHolderComponent, 
from '@components/ehss/history/historyItem/body/notifications/NotificationHolderComponent';
import BodyTitleComponent from '@components/history/historyItem/body/bodyTitleComponent';
import { faArrowRight, faCheckCircle, faClock, faEnvelopeOpen, faReceipt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import IWorkflow from '@interfaces/IWorkflow';
import { StatusProcess } from '@src/helpers/Enums';
import I18n from '@src/i18n';
import styled, { Theme } from '@src/styled-components';
import { Col, Row, Timeline } from 'antd';
import moment from 'moment';
import * as React from 'react';

import TableHistoryComponent from './ehss/TableHistoryComponent';


interface ItemComponentProp {
  id: number;
  register: any;
  type: string;
  workflow?: IWorkflow;
  name?: string;
  extrafields: any;
}

interface ItemComponentState {
  collapsed: boolean;
  tasks: any;
  localRegister: any;
}

export default class ItemComponent extends React.Component<ItemComponentProp, ItemComponentState> {

  constructor(prop: ItemComponentProp) {
    super(prop);

    this.toggleCollapsed = this.toggleCollapsed.bind(this);

    this.state = {
      collapsed: true,
      tasks: undefined,
      localRegister: undefined,
    };

  }

  componentDidMount() {
    this.setState({ collapsed: false });
  }


  private toggleCollapsed() {
    if (this.state.collapsed) {
      this.setState({
        collapsed: !this.state.collapsed,
        tasks: this.props.register.value.components,
      });
    } else {
      this.setState({
        collapsed: !this.state.collapsed,
        tasks: undefined,
      });
    }
  }

  getExtrafields(extrafields: any) {
    let labelsFields: JSX.Element[] = []
    for (let fields of extrafields) {
      if (this.props.extrafields) {
        const label = this.props.extrafields.find((e: any) => e.id === fields.label)
        if (label) {
          labelsFields.push(
            <div key={fields.label}>
              <span>{label.name}: {fields.value}</span>
            </div>
          )
        }
      }
    }
    return labelsFields;
  }


  formatHTML(label: any) {
    return { __html: label };
  }

  private getProcessNameFromRegister(register: any, type: string) {
    if (!!this.props.name) {
      return <span dangerouslySetInnerHTML={this.formatHTML(this.props.name)}></span>
      // return this.props.name;
    }
    switch (type) {
      case "process": {
        return <span dangerouslySetInnerHTML={this.formatHTML(register.label)}></span> || 'PROCESS TITLE';
      }

      case "notification": {
        return <span dangerouslySetInnerHTML={this.formatHTML(register.label)}></span> || "NOTIFICATION TITLE";
      }

      case "report": {
        return <span dangerouslySetInnerHTML={this.formatHTML(register.label)}></span> || "REPORT TITLE";
      }

      default:
        return "errorOnType at GetProcessNameFromRegister";
    }
  }

  renderContent() {
    const { register } = this.props;
    const startAt = new Date(register.startAt);
    const startAtFormated = moment(startAt).format(I18n.l('common.dateTimeFormat'))
    const newStartAt = startAtFormated.split(' ')
    const modifiedAt = new Date(register.modifiedAt);
    const modifiedAtFormated = moment(modifiedAt).format(I18n.l('common.dateTimeFormat'))
    const newmodifiedAt = modifiedAtFormated.split(' ')

    if (this.state.collapsed) {
      return (
        <Row className="goepik-side-padding-items">

          <Col sm={24} md={24} xl={24}>
            {
              ((this.props.type === "process" && register.value) &&
                <>
                  <div>
                    <Row>
                      <Col sm={5} md={5} xl={5}>
                        {(register.value && register.value.auditor) &&
                          <>
                            <div style={{ fontWeight: 'bold' }}>{I18n.l('history.ticket.executor')} </div>
                            <div>{register.value.auditor.name}</div>
                            <div>{I18n.l('table.auditors.registration')}: <span>{register.value.auditor.username}</span> </div>
                            {register.value.auditor.id === 'GUEST_ID' &&
                              <div>{I18n.l('labels.auditorGuest')}</div>
                            }
                            {register.value.auditor.fields &&
                              this.getExtrafields(register.value.auditor.fields)
                            }
                          </>
                        }
                        {(register.value && register.value.product) &&
                          <>
                            <div style={{ fontWeight: 'bold' }}>{I18n.l('history.ticket.product')} </div>
                            <div>{register.value.product.name}</div>
                            <div>{I18n.l('history.ticket.productCode')}: <span>{register.value.product.code}</span> </div>
                          </>
                        }
                      </Col>
                      <Col sm={5} md={5} xl={5}>
                        {(register.value && register.value.audited) &&
                          <>
                            <div style={{ fontWeight: 'bold' }}>{I18n.l('history.ticket.executedAt')} </div>
                            <div>{register.value.audited.name}</div>
                            <div>{I18n.l('table.auditors.registration')}: <span>{register.value.audited.username}</span> </div>
                            {register.value.auditedOut &&
                              <div>{I18n.l('labels.auditedOut')}</div>
                            }
                            {
                              register.value.audited.fields &&
                              this.getExtrafields(register.value.audited.fields)
                            }
                          </>
                        }
                        {(register.value && register.value.productionLine) &&
                          <>
                            <div style={{ fontWeight: 'bold' }}>{I18n.l('history.ticket.productionLine')} </div>
                            <div>{register.value.productionLine.code}</div>
                          </>
                        }
                      </Col>
                      {(register.value && register.value.workstation) &&
                        <Col sm={5} md={5} xl={5}>
                          <>
                            <div style={{ fontWeight: 'bold' }}>{I18n.l('history.ticket.workstation')} </div>
                            <div>{register.value.workstation.code}</div>
                          </>
                        </Col>
                      }
                      <Col sm={4} md={4} xl={4}>
                        {(register.value) &&
                          <>
                            <div style={{ fontWeight: 'bold' }}>{I18n.l('table.startAt')} </div>
                            <div>
                              {newStartAt[0]}
                            </div>
                            <div className='time-style'>
                              {newStartAt[1]}
                            </div>
                          </>
                        }
                      </Col>
                      <Col sm={4} md={4} xl={4}>
                        {(register.value) &&
                          <>
                            <div style={{ fontWeight: 'bold' }}>{I18n.l('table.finishtAt')} </div>
                            <div>
                              {newmodifiedAt[0]}
                            </div>
                            <div className='time-style'>
                              {newmodifiedAt[1]}
                            </div>
                          </>
                        }
                      </Col>
                      <Col sm={6} md={6} xl={6}>
                        {(register.value && register.value.info) &&
                          <>
                            <div style={{ fontWeight: 'bold' }}>{I18n.l('history.audits.risk.title')} </div>
                            <div>{register.value.info[0].description}</div>
                          </>
                        }
                      </Col>
                    </Row>
                  </div>
                  <div style={{ paddingTop: '3rem' }}>
                    <TableHistoryComponent sections={register.value.sections} process={register.process || null} />
                  </div>
                </>
              )
            }{
              ((this.props.type === "notification" && register.value) &&
                <NotificationHolderComponent
                  body={register.value.content}
                  receivers={register.value.destinations}
                  notifyFailed={register.value.sent}
                />
              )
            }
            {
              ((this.props.type === "report" && register.value) &&
                <a style={{ marginLeft: '1rem' }} href={register.value.file} target="_blank">{I18n.l('history.openReport')}</a>
              )
            }
          </Col>
        </Row>
      )
    }

    return;
  }

  public render() {
    const { register } = this.props;

    return (
      <>
        <GoEpikTimelineItem>
          <Timeline.Item
            key={this.props.id}
            dot={
              <>
                {(register.value && register.value.status === StatusProcess.DONE) &&
                  <Icon style={{ color: '#038119', fontSize: '24px' }} icon={faCheckCircle} />
                }

                {(register.value && register.value.status === StatusProcess.IN_PROGRESS) &&
                  <Icon style={{ color: '#038119', fontSize: '24px' }} icon={faArrowRight} />
                }

                {(!register.value) &&
                  <Icon style={{ color: `${Theme.secondary.midGrey}`, fontSize: '24px' }} icon={faClock} />
                }

                {(register.value && register.value.destinations) &&
                  <Icon style={{ color: '#038119', fontSize: '24px' }} icon={faEnvelopeOpen} />
                }
                {(register.value && register.value.file) &&
                  <Icon style={{ color: '#038119', fontSize: '24px' }} icon={faReceipt} />
                }

              </>
            }>
            <Row className="goepik-side-padding">
              <Col sm={24} md={24} xl={24}>
                <div className="goepik-clickable goepik-item-title" onClick={this.toggleCollapsed}>

                  <BodyTitleComponent
                    title={this.getProcessNameFromRegister(register, this.props.type)}
                    collapsed={this.state.collapsed}
                    ticket={register.value}
                  />
                </div>
              </Col>
            </Row>
            {
              this.renderContent()
            }
          </Timeline.Item>

        </GoEpikTimelineItem>
      </>
    );
  }
}

const GoEpikTimelineItem = styled.div`
    .goepik-timeline-done{
        .ant-badge-count{
            background-color: #fff!important;
            color: ${Theme.standard.green}!important;
            box-shadow: '0 0 0 1px #d9d9d9 inset!important'
        },
        .ant-avatar {
          background: green !important;
          color:${Theme.standard.white}!important;
          border-color:${Theme.primary.regular}!important;
      }
    }

    .goepik-timeline-inprogess{
      .ant-badge-count{
          background-color: #fff!important;
          color: ${Theme.standard.green}!important;
          box-shadow: '0 0 0 1px #d9d9d9 inset!important'
      },
      .ant-avatar {
        background: yellow !important;
        color:${Theme.standard.white}!important;
        border-color:${Theme.primary.regular}!important;
    }
  }

  .goepik-timeline-pendent{
    .ant-badge-count{
        background-color: #fff!important;
        color: ${Theme.standard.green}!important;
        box-shadow: '0 0 0 1px #d9d9d9 inset!important'
    },
}

    .ant-timeline-item {
        position: relative;
        padding: 0 0 20px;
        list-style: none;
        margin: 0;
        font-size: 14px;
    }



    .goepik-timeline-item-status{
        .ant-timeline-item-head{
            background-color: ${Theme.primary.regular}!important;
        }
    }

    .goepik-timeline-signature{
        min-height: 83px!important;
        position: absolute;
        padding-left: 45pxpx;
        padding-right: 24px;
        left: -18em;
        font-size: 14px;
    }

    .goepik-text-right{
        text-align: right;
    }

    .goepik-side-padding{
        padding-left: 24px!important;
        padding-right: 24px!important;
    }

    .goepik-side-padding-items{
        padding-left: 12px!important;
        padding-right: 24px!important;
    }

    .goepik-component-no-margin-bottom{
        margin-bottom: 0px!important;
    }

    .goepik-timeline-signature {
        min-height: 83px!important;
        position: absolute;
        padding-right: 24px;
        left: -18rem;
        font-size: 14px;
    }

    .goepik-item-title{
        font-size:16px;
    }

    .goepik-clickable{
        cursor: pointer;
    }
`;
